// import React from 'react'

// export default function Checkout() {
//   return (
//     <div>Checkout</div>
//   )
// }


import { useState } from 'react';
import { useCart } from '../Context/Cart'; // تأكد من المسار الصحيح

export default function Checkout() {
  const { cartItems, totalPrice } = useCart();
  
  // حالات النموذج
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    address: '',
    address2: '',
    country: '',
    state: '',
    zip: '',
    sameAddress: false,
    saveInfo: false,
    paymentMethod: 'credit',
    nameOnCard: '',
    cardNumber: '',
    expiration: '',
    cvv: ''
  });

  const [promoCode, setPromoCode] = useState('');
  const [discount, setDiscount] = useState(0);

  // حساب تكلفة الشحن
  const shippingCost = cartItems.length > 0 ? 5.99 : 0;
  
  // حساب المجموع النهائي
  const finalTotal = totalPrice + shippingCost - discount;

  // تعامل مع تغيير البيانات
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // تطبيق كود الخصم
  const applyPromoCode = () => {
    if (promoCode.toUpperCase() === 'EXAMPLECODE') {
      setDiscount(5);
    } else {
      setDiscount(0);
      alert('Invalid promo code');
    }
  };

  // إرسال الطلب
  const handleSubmit = (e) => {
    e.preventDefault();
    if (cartItems.length === 0) {
      alert('Your cart is empty!');
      return;
    }
    
    // هنا يمكنك إضافة منطق معالجة الطلب
    alert('Order placed successfully!');
    console.log('Order data:', { formData, cartItems, totalPrice: finalTotal });
  };

  return (
    <div className="container py-5">
      <div className="row">
        {/* نموذج الدفع */}
        <div className="col-lg-8">
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="card-title mb-4">Checkout</h2>
              
              <form onSubmit={handleSubmit}>
                {/* عنوان الفاتورة */}
                <div className="mb-4">
                  <h4>Billing Address</h4>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">First name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Last name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <div className="input-group">
                      <span className="input-group-text">@</span>
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        placeholder="Username"
                      />
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Email (Optional)</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="you@example.com"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="1234 Main St"
                      required
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Address 2 (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address2"
                      value={formData.address2}
                      onChange={handleInputChange}
                      placeholder="Apartment or suite"
                    />
                  </div>
                  
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Country</label>
                      <select
                        className="form-select"
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Choose...</option>
                        <option value="US">United States</option>
                        <option value="CA">Canada</option>
                        <option value="UK">United Kingdom</option>
                        <option value="EG">Egypt</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">State</label>
                      <select
                        className="form-select"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Choose...</option>
                        <option value="CA">California</option>
                        <option value="NY">New York</option>
                        <option value="TX">Texas</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Zip</label>
                      <input
                        type="text"
                        className="form-control"
                        name="zip"
                        value={formData.zip}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="sameAddress"
                      checked={formData.sameAddress}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">
                      Shipping address is the same as my billing address
                    </label>
                  </div>
                  
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="saveInfo"
                      checked={formData.saveInfo}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">
                      Save this information for next time
                    </label>
                  </div>
                </div>

                {/* طريقة الدفع */}
                <div className="mb-4">
                  <h4>Payment</h4>
                  
                  <div className="form-check mb-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="paymentMethod"
                      value="credit"
                      checked={formData.paymentMethod === 'credit'}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">Credit card</label>
                  </div>
                  
                  <div className="form-check mb-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="paymentMethod"
                      value="debit"
                      checked={formData.paymentMethod === 'debit'}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">Debit card</label>
                  </div>
                  
                  <div className="form-check mb-3">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="paymentMethod"
                      value="paypal"
                      checked={formData.paymentMethod === 'paypal'}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label">PayPal</label>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Name on card</label>
                      <input
                        type="text"
                        className="form-control"
                        name="nameOnCard"
                        value={formData.nameOnCard}
                        onChange={handleInputChange}
                        placeholder="Full name as displayed on card"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Credit card number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="cardNumber"
                        value={formData.cardNumber}
                        onChange={handleInputChange}
                        placeholder="1234 5678 9012 3456"
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Expiration</label>
                      <input
                        type="text"
                        className="form-control"
                        name="expiration"
                        value={formData.expiration}
                        onChange={handleInputChange}
                        placeholder="MM/YY"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">CVV</label>
                      <input
                        type="text"
                        className="form-control"
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleInputChange}
                        placeholder="123"
                      />
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-lg w-100"
                  disabled={cartItems.length === 0}
                >
                  Place Order
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* ملخص الطلب */}
        <div className="col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="card-title mb-4">Your Cart</h4>
              
              {/* عرض المنتجات */}
              {cartItems.length === 0 ? (
                <p className="text-muted">Your cart is empty</p>
              ) : (
                <div className="mb-4">
                  {cartItems.map((item) => (
                    <div key={item.id} className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{item.name}</h6>
                        <p className="text-muted mb-0 small">
                          Quantity: {item.quantity}
                        </p>
                      </div>
                      <span className="fw-bold">
                        ${(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              )}
              
              {/* كود الخصم */}
              <div className="mb-4">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Promo code"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={applyPromoCode}
                  >
                    Redeem
                  </button>
                </div>
                {discount > 0 && (
                  <small className="text-success">
                    Discount applied: -${discount.toFixed(2)}
                  </small>
                )}
              </div>
              
              {/* ملخص الأسعار */}
              <div className="border-top pt-3">
                <div className="d-flex justify-content-between mb-2">
                  <span>Products ({cartItems.length})</span>
                  <span>${totalPrice.toFixed(2)}</span>
                </div>
                
                <div className="d-flex justify-content-between mb-2">
                  <span>Shipping</span>
                  <span>${shippingCost.toFixed(2)}</span>
                </div>
                
                {discount > 0 && (
                  <div className="d-flex justify-content-between mb-2 text-success">
                    <span>Discount</span>
                    <span>-${discount.toFixed(2)}</span>
                  </div>
                )}
                
                <div className="d-flex justify-content-between fw-bold border-top pt-2">
                  <span>Total (USD)</span>
                  <span>${finalTotal.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}